import Checkbox from './Checkbox';

// export types
export type { CheckboxProps } from './Checkbox';

// export components
export { Checkbox };
export default Checkbox;
